import Message from './Message';
import Alert from './Alert';
import SignUp from './SignUp';
import SignOut from './SignOut';
import TempAlert from './TempAlert';

export const alertType = {
    message: 'link',
    alert: 'alert',
    sign_up: 'sign_up',
    sign_out: 'sign_out',
    temp_alert: 'temp_alert'
};

export const alertComponent = {
    message: Message,
    alert: Alert,
    sign_up: SignUp,
    sign_out: SignOut,
    temp_alert: TempAlert
};